import { render } from "./RegisterSystemEspecificAcess.vue?vue&type=template&id=e8d44f44"
import script from "./RegisterSystemEspecificAcess.vue?vue&type=script&lang=js"
export * from "./RegisterSystemEspecificAcess.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__